import React from 'react';
import { publicationsData } from '../mock';
import { FileText, ExternalLink, Download } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Publications = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const publications = publicationsData[language] || publicationsData['en'];

  const handleDocumentClick = (pub, e) => {
    if (pub.isPdf) {
      e.preventDefault();
      // Open PDF in new tab
      window.open(pub.pdfLink, '_blank', 'noopener,noreferrer');
    }
    // For external links and docx, default behavior will work
  };

  const getButtonText = (pub) => {
    if (pub.isDocx) {
      return language === 'tr' ? 'İndir' : language === 'fr' ? 'Télécharger' : language === 'de' ? 'Herunterladen' : 'Download';
    } else if (pub.isExternal) {
      return t.publications.viewExternal;
    } else {
      return t.publications.download;
    }
  };

  const getButtonIcon = (pub) => {
    if (pub.isDocx) {
      return <Download className="w-4 h-4" />;
    } else if (pub.isExternal) {
      return <ExternalLink className="w-4 h-4" />;
    } else {
      return <ExternalLink className="w-4 h-4" />;
    }
  };

  return (
    <section id="publications" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">
            {t.publications.title}
          </h2>
          <div className="w-24 h-1 bg-gray-900 mx-auto"></div>
        </div>

        <div className="max-w-5xl mx-auto space-y-8">
          {publications.map((pub, index) => (
            <div
              key={index}
              className="bg-white p-8 border border-gray-200 hover:border-gray-400 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-start gap-4">
                <div className="mt-1 text-gray-900">
                  <FileText className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-serif font-semibold text-gray-900 mb-2">
                    {pub.title}
                  </h3>
                  <div className="flex flex-wrap items-center gap-3 text-sm text-gray-600 mb-4">
                    <span className="font-medium">{pub.journal}</span>
                    <span className="text-gray-400">•</span>
                    <span>{pub.date}</span>
                  </div>
                  <p className="text-gray-700 leading-relaxed mb-4 text-justify">
                    {pub.summary}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {pub.isDocx ? (
                      <a
                        href={pub.pdfLink}
                        download
                        className="inline-flex items-center gap-2 text-gray-900 font-medium hover:text-gray-700 transition-colors group"
                      >
                        <span className="border-b-2 border-gray-900 group-hover:border-gray-700">
                          {getButtonText(pub)}
                        </span>
                        {getButtonIcon(pub)}
                      </a>
                    ) : (
                      <a
                        href={pub.pdfLink}
                        onClick={(e) => handleDocumentClick(pub, e)}
                        className="inline-flex items-center gap-2 text-gray-900 font-medium hover:text-gray-700 transition-colors group"
                        target={pub.isExternal ? "_blank" : "_self"}
                        rel={pub.isExternal ? "noopener noreferrer" : ""}
                      >
                        <span className="border-b-2 border-gray-900 group-hover:border-gray-700">
                          {getButtonText(pub)}
                        </span>
                        {getButtonIcon(pub)}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
